// extracted by mini-css-extract-plugin
module.exports = {"button":"PageButtons_button__3Sj8z","buttonCol":"PageButtons_buttonCol__ROVa3","buttonDevision":"PageButtons_buttonDevision__1_jT_"};